<template>
    <div id="map" :style="isMobile ? 'width: 96vw;' : ''">
        <div
            id="mapContainer"
            :style="
                isMobile ? 'height: calc(100vh - 330px); width: 100%' : 'height: 800px; width: 100%'
            "
            ref="hereMap"
        />
    </div>
</template>

<script lang="ts">
import getEnv from "../env";

const env = getEnv();
import { getDistance } from "../services/expenseReportDistance";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { useDisplay } from "vuetify";

@Component({
    emits: ["distance"],
})
export class HereMap extends Vue {
    @Prop({ default: null }) origin!: any;
    @Prop({ default: null }) destination!: any;
    @Prop({ default: "car" }) vehiculeType!:
        | "CAR"
        | "TWO_REAR_WHEELS_GT_50"
        | "TWO_REAR_WHEELS_LTE_50"
        | "BICYCLE";

    transportModesMap = {
        CAR: "car",
        TWO_REAR_WHEELS_GT_50: "scooter",
        TWO_REAR_WHEELS_LTE_50: "scooter",
        BICYCLE: "bicyle",
    };
    platform = null;
    map = null;
    router = null;
    H: any = null;
    pin = null;
    distance = 0;
    currentRoute = [];
    public isMobile: boolean;
    get routingParameters() {
        let origin = "";
        let destination = "";
        if (this.origin && this.destination) {
            origin = this.origin.latitude + "," + this.origin.longitude;
            destination = this.destination.latitude + "," + this.destination.longitude;
        }
        return {
            routingMode: "fast",
            transportMode: this.transportModesMap[this.vehiculeType],
            origin: origin,
            destination: destination,
            return: "polyline,travelSummary",
        };
    }

    created() {
        const { mobile } = useDisplay();
        this.isMobile = mobile.value;
    }

    async mounted() {
        // pas bien faire cette chose. TODO give H a title and maybe a better name ?
        this.H = (window as any).H;
        debugger;
        this.platform = new this.H.service.Platform({
            apikey: env.HEREMAP_APIKEY,
        });
        this.router = this.platform.getRoutingService(null, 8);
        this.pin = this.getPin();
        this.initializeHereMap();
    }

    initializeHereMap() {
        // rendering map
        const mapContainer = this.$refs.hereMap;

        const maptypes = this.platform.createDefaultLayers();
        this.map = new this.H.Map(mapContainer, maptypes.vector.normal.map, {
            zoom: 5.8,
            center: {
                // Center of France
                lat: 46.227638,
                lng: 2.213749,
                pixelRatio: Math.min(devicePixelRatio, 2),
            },
        });

        addEventListener("resize", () => this.map.getViewPort().resize());

        // // capture the map  in canvas
        // this.map.capture(function(capturedCanvas) {
        //     // remove previously added canvas from the overlay
        //     captureBackground.innerHTML = '';
        //     captureBackground.appendChild(capturedCanvas);
        //     document.body.appendChild(captureBackground);
        // }, [], 50, 50, 700, 700);

        // new this.H.mapevents.Behavior(new this.H.mapevents.MapEvents(this.map)); // Permet de déplacer la map
        // this.H.ui.UI.createDefault(this.map, maptypes); // Affiche a scale bar le traffic etc
        this.getDistance();
    }

    @Watch("origin")
    @Watch("destination")
    async getDistance() {
        let origin = "";
        let destination = "";
        if (this.origin && this.destination) {
            origin = this.origin.latitude + "," + this.origin.longitude;
            destination = this.destination.latitude + "," + this.destination.longitude;
        }
        const payload = {
            origin,
            destination,
            vehiculeType: this.vehiculeType,
        };
        this.distance = await getDistance(payload);
        this.router.calculateRoute(
            this.routingParameters,
            (r) => {
                if (r?.routes?.[0]?.sections.length) {
                    const s = r.routes[0].sections[0];
                    if (this.currentRoute.length) {
                        this.map.removeObjects(this.currentRoute);
                    }
                    const linestring = this.H.geo.LineString.fromFlexiblePolyline(s.polyline);
                    const routeLine = new this.H.map.Polyline(linestring, {
                        style: { strokeColor: "#f8b129", lineWidth: 6 },
                    });
                    const startMarker = new this.H.map.Marker(s.departure.place.location, {
                        icon: this.pin,
                    });
                    const endMarker = new this.H.map.Marker(s.arrival.place.location, {
                        icon: this.pin,
                    });
                    // console.log("BoundingBox", routeLine.getBoundingBox())
                    this.currentRoute = [routeLine, startMarker, endMarker];
                    this.map.addObjects([routeLine, startMarker, endMarker]);
                    const boundingBox = this.getBoundingBox(routeLine.getBoundingBox());
                    this.map.getViewModel().setLookAtData({ bounds: boundingBox });
                    // this.restrictMap(boundingBox)
                }
                debugger;
                this.$emit("distance", this.distance);
            },
            function (error) {
                console.error(error.message);
            },
        );
    }

    getBoundingBox(originBoundingBox) {
        if (this.routingParameters.origin && this.routingParameters.destination) {
            const zoomRate = 1.1; // 10% marge

            // get the bounding box of the map
            const originBoundingBoxHeight = originBoundingBox.getHeight();
            const originBoundingBoxWidth = originBoundingBox.getWidth();

            // calculate the new bounding box
            const latitudeToAdd = originBoundingBoxHeight * zoomRate - originBoundingBoxHeight;
            const longitudeToAdd = originBoundingBoxWidth * zoomRate - originBoundingBoxWidth;

            // create a new bounding box
            return new this.H.geo.Rect(
                originBoundingBox.getTop() + latitudeToAdd,
                originBoundingBox.getLeft() - longitudeToAdd,
                originBoundingBox.getBottom() - latitudeToAdd,
                originBoundingBox.getRight() + longitudeToAdd,
            );
        }
    }

    getPin() {
        //
        const svg = `<svg width="46" height="46" fill="#F9B12A" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke="#FFF" stroke-width="1" stroke-linecap="round">
                    <path d="M12 21.6s7.2-6.823 7.2-12a7.2
                        7.2 0 0 0-14.4 0c0 5.177 7.2 12 7.2
                        12Zm0-8.4A3.6 3.6 0 1 1 12
                        6a3.6 3.6 0 0 1 0 7.2Z"></path>
                </svg>`;
        return new this.H.map.Icon(svg, { anchor: { x: 23, y: 42 } });
    }

    restrictMap(originBoundingBox) {
        this.map.getViewModel().addEventListener("sync", function () {
            const center = this.map.getCenter();
            if (!originBoundingBox.containsPoint(center)) {
                if (center.lat > originBoundingBox.getTop()) {
                    center.lat = originBoundingBox.getTop();
                } else if (center.lat < originBoundingBox.getBottom()) {
                    center.lat = originBoundingBox.getBottom();
                }
                if (center.lng < originBoundingBox.getLeft()) {
                    center.lng = originBoundingBox.getLeft();
                } else if (center.lng > originBoundingBox.getRight()) {
                    center.lng = originBoundingBox.getRight();
                }
                this.map.setCenter(center);
            }
        });
    }
}

export default toNative(HereMap);
</script>
